exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.best_buys_config_pane[data-v-81828e22] {\n   display: -webkit-box;\n   display: -ms-flexbox;\n   display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n[data-v-81828e22] .el-alert {\n    padding: 0;\n}\n", ""]);

// exports
